$shm_hitalama_text $mol_text
	favicon true
	render_visible_only false
	Embed* $shm_hitalama_text_embed
		uri <= link_uri*
		title <= line_text*
	Quote* $shm_hitalama_text
		uri_resolve* <= uri_resolve*
		text <= quote_text*
		highlight <= highlight
		favicon <= favicon
		auto_scroll null
	Pre* $shm_hitalama_text_code
		text <= pre_text*
		row_themes <= pre_themes*
		highlight <= highlight
		uri_resolve* <= uri_resolve*
		sidebar_showed <= pre_sidebar_showed
	Table* $shm_hitalama_text_table
		head_cells <= table_head_cells*
		rows <= table_rows*
	Grid* $shm_hitalama_text_table
		rows <= grid_rows*
	Spoiler_content* $shm_hitalama_text
		text <= spoiler_content*
	List* $shm_hitalama_text_list
		uri_resolve* <= uri_resolve*
		type <= list_type*
		text <= list_text*
		highlight <= highlight
		favicon <= favicon
